import { NextSeo, NextSeoProps } from "next-seo";

import { ColumnListLayout } from "features/media/components/template/ColumnListLayout";
import { useTopicList } from "repositories/hooks/useTopicList";
import { useRouter } from "next/router";
import Layout from "components/layout";
import { MediaHeader } from "features/media/components/atoms/MediaHeader";
import { MediaNav } from "features/media/components/atoms/MediaNav";
import { ReactNode } from "react";
import { GetServerSideProps } from "next";
import getNextSeoProps from "utils/ssr/getNextSeoProps";
import { useTopicCategoryList } from "repositories/hooks/useTopicCategoryList";

const perPage = 10;

interface Props {
  nextSeoProps: NextSeoProps;
}

const MiracleColumnListPage = ({ nextSeoProps }: Props) => {
  const { query } = useRouter();

  const currentPage = query.page || 1;

  const { topics, meta, isLoading } = useTopicList("miracle", {
    page: currentPage,
    limit: perPage,
  });
  const { categories } = useTopicCategoryList("miracle");

  return (
    <>
      <NextSeo {...nextSeoProps} />
      <ColumnListLayout
        title="占い"
        topics={topics}
        categories={categories}
        currentPage={currentPage}
        totalPage={meta.totalPages}
        isLoading={isLoading}
      />
    </>
  );
};

export default MiracleColumnListPage;

MiracleColumnListPage.getLayout = (page: ReactNode) => {
  return (
    <Layout header={<MediaHeader />} nav={null}>
      <MediaNav />
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const currentPage = ctx.query?.page;

  const title = `(${currentPage}ページ目) miracleのまとめ一覧`;
  const description = `(${currentPage}ページ目) miracleは、無料占いコンテンツや占いにまつわる情報をまとめた占いメディアです。パワースポットや人気占い師、手相占い、星座占い、相性占い、タロット占いなど占いにまつわる幅広い情報が満載です。`;
  const url = "https://miror.jp/miracle/column";

  const nextSeoProps = getNextSeoProps(ctx, {
    title,
    description,
    url,
    options: {
      additionalLinkTags: [{ rel: "icon", href: "/favicon.ico" }],
      openGraph: {
        title,
        description,
        url,
        type: "article",
        site_name: "ミラクル",
      },
      noindex: true,
      nofollow: true,
    },
  });

  return {
    props: {
      nextSeoProps,
    },
  };
};
